import { useEffect, useState } from "react"
import Scalar from "src/libs/scalars/scalars/Scalar"
import "../../assets/css/scalars.scss"
import { ScreenPlace } from "../../data/interfaces"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { Position } from "@blueprintjs/core"

/* Protopia Ecosystem component */ 
export interface IProportionScalarProps extends ICompositeWidgetProps {
    columns: number
}
const ScreenPositionScalar = (props: IProportionScalarProps): JSX.Element => {
    return <>
        <Scalar 
            title={props.title}
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<ScreenPositionEnabled {...props}  columns={props.columns} />}  
            desabledForm={<ScreenPositionDisable {...props} columns={props.columns} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu} 
        />
    </>
}

export default ScreenPositionScalar

const ScreenPositionEnabled = (props: IProportionScalarProps): JSX.Element => {
    const [value, setValue] = useState<Position>( props.value || Position.RIGHT_BOTTOM ) 
    useEffect(() => {
        setValue( props.value || [] )
    }, [ props.value ])

    const onClick = ( sp: Position ) => {
        setValue( sp )
        if( props.onChange ) {
            props.onChange( sp, props.field, "" )
        }
    }
    return <div className="w-100 mb-3 px-3"> 
        <div className="screen-position-container" style={{maxHeight: 600}}>
            {
                ScreenPlace.map((sp: Position) => {
                    return <div 
                        className={ `screen-place ${ sp === value ? "active" : "" }` } 
                        key={ sp } 
                        data-screen-place={ sp }
                        onClick={ () => onClick( sp ) }
                    >

                    </div>
                })
            }
        </div>    
    </div>    
}
const ScreenPositionDisable = (props: IProportionScalarProps): JSX.Element => {
    const [value, setValue] = useState<any[]>( props.value || [] ) 
    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])
    return <>
        ScreenPositionDisable
    </>
}